// Source: app/scripts/directives/multilingual-html-field.js
Auction.directive('multilingualHtmlField', ['crudService', function(crudService) {
    return {
        restrict: 'E',
        templateUrl: 'directives/multilingual-html-field.html',
        scope: {
            field: '@',
            required: '=',
            entity: '='
        }
    };
}]);